<div class="fw-lighter opacity-50">{{label}}</div>